// extracted by mini-css-extract-plugin
export var falconContainer = "_vz-2";
export var offerCenter = "_vz-0";
export var roktContainer = "_vz-1";